import type { TwoFactorLabels } from '@bak/admin-ui'

import { ApiError, errorMessage } from '../../api/client.js'
import type { T } from '../../i18n/index.js'

// Two-factor sign-in (#227): the shared components' text, and the API's answers in the admin's own language.

export const twoFactorLabels = (t: T): TwoFactorLabels => ({
  setupIntro: t('auth.2fa.setupIntro'),
  qr: t('auth.2fa.qr'),
  manualKey: t('auth.2fa.manualKey'),
  code: t('auth.2fa.code'),
  turnOn: t('auth.2fa.turnOn'),
  working: t('auth.2fa.working'),
  recoveryTitle: t('auth.2fa.recoveryTitle'),
  recoveryIntro: t('auth.2fa.recoveryIntro'),
  copy: t('auth.2fa.copy'),
  copied: t('auth.2fa.copied'),
  download: t('auth.2fa.download'),
  saved: t('auth.2fa.saved'),
})

/** 422 wrong code, 429 too many tries, 401 the pending step is gone; anything else as the API says it. */
export function twoFactorError(err: unknown, t: T): string {
  if (err instanceof ApiError) {
    if (err.status === 422) return t('auth.2fa.wrongCode')
    if (err.status === 429) return t('auth.2fa.locked')
    if (err.status === 401) return t('auth.2fa.expired')
  }
  return errorMessage(err)
}
